import React, { useEffect, useState } from "react";
import { Button, Input } from "react-onsenui";
import OTPScreen from "./OTPScreen.js";
import { generateOTP } from "../apiService.js"; // Import the API service for OTP generation
import { Navbar } from "../index.js";
import { FormNextLink } from "grommet-icons";
import { useTranslation } from "react-i18next";
import "../i18n.js";
import i18n from "../i18n.js";
import Dialog from "./AlertDialog.js"; // Import custom Dialog component
import myLogo2 from '../ratifi-2.png'
import  ReactPWAInstallProvider,{ useReactPWAInstall } from "react-pwa-install";
const LoginScreen = (props) => {

    const handleClick = () => {
      pwaInstall
      ({
        title: "RatiFi Redux",
        logo: myLogo2,
        features: (
          <ul>
            <li>Upload Claim Status</li>
            <li>Tutorials & Manuals</li>
            <li>Help & Support</li>
            <li>Works offline</li>
          </ul>
        ),
        description: "RatiFi Redux is designed to facilitate the CFR claim generation process and it includes a tracking system to monitor progress on claim approval. ",
      })
        .then((e) => {
          console.warn(e)
          // alert("App installed successfully or instructions for install shown")
        })
        .catch(() => alert("User opted out from installing"));
    };
    
  const { navigator, setIsLoggedIn } = props;
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("en");
  const [key, setKey] = useState(0); 
  const [dialogVisible, setDialogVisible] = useState(false); 
  const [dialogMessage, setDialogMessage] = useState(""); 
 const { pwaInstall, supported, isInstalled } = useReactPWAInstall();

  useEffect(() => {
    i18n.changeLanguage(language).then(() => {
      setKey((prevKey) => prevKey + 1); // Trigger re-render
    });
  }, [language]);

 
  const handleLogin = async () => {
    if (!username || username.length !== 10 || !/^\d{10}$/.test(username)) {
      setDialogMessage(t("Please enter a valid 10-digit mobile number."));
      setDialogVisible(true); // Show dialog instead of alert
      return;
    }
  
    setLoading(true);
    try {
      const response = await generateOTP({
       mobile: username,
       name:'Dummy-name'
      });
      console.warn(response)
      navigator.pushPage({
        title: "OTPScreen",
        component: OTPScreen,
        data: { contact: username },
      });
    } catch (error) {
      console.warn("error", error);
      alert("Please check your internet connection")
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div
      style={{
        textAlign: "center",
        background: "white",
        paddingBottom: 10,
        padding: 10,
        height:'100vh'
      }}
      key={key} // Use key to force re-render on language change
    >
        {supported() && !isInstalled() && (
       <div style={{

        background:'#5C7232',
        marginBottom:10,
        borderRadius:10,

       }}>
        <span style={{color:'white'}}>
        Click the button to install RatiFi Redux
          </span>
        
       <Button type="button" onClick={handleClick} style={{margin:10,color:'#5C7232',background:'white'}}>
          Install App
        </Button>
        </div>
      )}
      <Navbar language={language} setLanguage={setLanguage} />
      <h2>RatiFi Redux</h2>
      <b>
        <p>{t('App for Forest Rights Committee (FRC)')}</p>
      </b>
    
      {/* <label>{t("Enter Mocr")}</label> */}
      <div
  style={{
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
    border: "solid 1px gray",
    borderRadius: 5,
    padding: "5px 10px",
  }}
>
  <span style={{ marginRight: 5, fontWeight: "bold" }}>+91</span>
  <Input
  modifier="transparent"
    type="tel"
    value={username}
 
    onChange={(e) => {
      const input = e.target.value;
      if (/^\d*$/.test(input) && input.length <= 10) {
        setUsername(input); // Update state only if input is numeric and within 10 digits
      }
    }}
    placeholder={t("Please Enter Mobile Number")}
    style={{
      width: "100%",
      border: "none",
      outline: "none",
    }}
  />
</div>





      <p>
        {t(
          "We will send you an OTP on this mobile number, if not registered you can start the fresh registration"
        )}
      </p>
      <Button
        onClick={handleLogin}
        style={{ marginTop: "20px", background: "#5C7232" }}
        disabled={loading}
      >
        {loading ? (
          t("Sending...")
        ) : (
          <div>
            {t("SEND OTP")} <FormNextLink color="white" />
          </div>
        )}
      </Button>

      {/* Dialog component */}
      <Dialog
        visible={dialogVisible}
        setVisible={setDialogVisible}
        title={t("Error")}
        desc={dialogMessage}
      />
    </div>
  );
};

export default LoginScreen;
